import Reducer from "./redux/reducers";
import { combineReducers } from "redux";

const rootReducer = combineReducers({
  reducer: Reducer,
});

export default rootReducer;
